module.exports = __webpack_public_path__ + "img/t-9.d5663dc1.jpg";